/***
 * 隐私协议相关配置
 */
import { nanoid } from 'nanoid';

export default {
  reporType: 100181,
  //中文
  zh: {
    contentPlaceholder: '我们根据《隐私声明》保护您填写的所有信息',
    contentValue: '我们根据《隐私声明》保护您填写的所有信息',
    colorTextPlaceholder: '请输入第1行中包含的文字才能实现跳转效果',
    colorTextValue: '《隐私声明》',
    urlPlaceholder: '请输入以http://或https://开头的链接'
  },
  // 英文
  en: {
    contentPlaceholder:
      'We protect all the information you provide according to our 《Privacy Statement》',
    contentValue:
      'We protect all the information you provide according to our 《Privacy Statement》',
    colorTextPlaceholder: '请输入第1行中包含的文字才能实现跳转效果',
    colorTextValue: '《Privacy Statement》',
    urlPlaceholder: '请输入以http://或https://开头的链接'
  },
  // 创建一个隐私协议项
  create(lang = 'zh') {
    return {
      label: '隐私声明',
      subject: '隐私声明',
      privacy: true,
      activeCollapse: '0', // 扩展属性， 隐私声明可以多个，使用折叠面板展示,该属性标识当前展开的折叠面板
      options: {
        show_checkbox: 1,
        list: [
          {
            id: nanoid(),
            is_must: 1,
            content: this[lang].contentValue,
            options: [
              {
                color_text: this[lang].colorTextValue,
                url: ''
              }
            ]
          }
        ]
      },
      items: [],
      reporType: this.reporType,
      reqType: 6,
      default_type: 6,
      system_type: 6
    };
  }
};
